import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import KeyVaultCalc from '../components/calculators/KeyVaultCalc'

export default function KeyVaultPage() {
  return (
    <>
      <Helmet>
        <title>Azure Key Vault Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure Key Vault costs for UK South in GBP. Compare Standard, Premium, and Managed HSM tiers including operations, key storage, and certificate renewal pricing." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/key-vault" />
        <meta property="og:title" content="Azure Key Vault Cost Calculator UK" />
        <meta property="og:description" content="Key Vault Standard, Premium, and Managed HSM pricing for UK South. Most apps pay £0 — the 10,000 ops free tier covers typical usage." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/key-vault" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Key Vault Cost Calculator',
          description: 'Estimate Azure Key Vault costs for UK South including Standard, Premium, and Managed HSM tiers.',
          url: 'https://www.azure-calc.co.uk/key-vault',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Key Vault Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Software &amp; HSM keys · Certificates · Managed HSM
          </p>
        </div>

        <KeyVaultCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>
            Related guides
          </h2>
          <Link
            to="/guides/azure-key-vault-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold" style={{ color: 'var(--text-secondary)' }}>Azure Key Vault Pricing Guide UK 2026</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Standard vs Premium vs Managed HSM — why most apps pay nearly nothing</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
